var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"disabled":_vm.disabled || _vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click', $event)}}},[(_vm.loading)?_c('b-spinner',{staticClass:"mx-4",staticStyle:{"width":"1.3em","height":"1.3em","border-width":"0.2em"},attrs:{"label":"Loading..."}}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }